import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./theme/styles/main.scss";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, history } from "./store";

const container = document.getElementById("app-root")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);

reportWebVitals();
